export default {
  home: '/',
  recycling: '/recykling',
  recycling_2_trash: '/odpady',
  recycling_3_pet: '/butelka-pet',
  recycling_4_secondlife: '/drugie-zycie-butelki',
  programming: '/wprowadzenie-do-programowania',
  programming_2_cleanup: '/warto-by-tu-troche-posprzatac',
  programming_3_whats_that: '/czym-jest-programowanie',
  programming_4_code_syntax: '/jak-wyglada-linijka-kodu',
  programming_5_robot_control: '/sterowanie-skribotem',
  programming_6_first_task: '/pierwsze-zadanie',
  programming_7_first_quiz: '/ile-butelek-pet-potrzeba-do-produkcji-bluzy',
  programming_8_second_task: '/uzupelnij-brakujace-funkcje',
  programming_9_third_task: '/algorytm',
  programming_10_second_skribot: '/dolacza-drugi-skribot',
  programming_11_pet_quiz: '/czy-wiesz',
  programming_12_programming_logic: '/to-logiczne',
  programming_13_true_false_test: '/true-or-false',
  programming_14_parameters: '/parametr-wyjsciowy',
  programming_15_decission: '/czas-na-decyzje',
  programming_16_else_statements: '/instrukcja-warunkowa',
  programming_17_pet_bottle_sign_quiz: '/znak-graficzny-PET',
  programming_18_what_if: '/a-co-jesli',
  programming_19_more_conditions: '/wiecej-warunkow',
  programming_20_segregation: '/i-co-teraz-z-tymi-odpadami',
  programming_21_conditions: '/wyrazene-warunkowe',
  programming_22_yellow_bin_quiz: '/co-wrzucamy-do-zoltego-pojemnika',
  programming_23_object: '/obiekt-programistyczny',
  programming_24_segregation_process: '/proces-segregacji',
  programming_25_skribot_on_track: '/skribot-na-tasmie',
  programming_26_skribot_on_track_task: '/skribot-na-tasmie-zadanie',
  programming_27_skribot_on_track_second_task: '/skribot-na-tasmie-drugie-zadanie',
  programming_28_and_or: '/operacje-na-wyrazeniach-logicznych',
  programming_29_true_false_second_quiz: '/true-or-false-quiz',
  programming_30_skribot_on_track_third_task: '/skribot-na-tasmie-trzecie-zadanie',
  programming_31_second_skribot_on_track: '/dwa-skriboty-na-tasmie',
  programming_32_while: '/petla-while',
  programming_33_skribot_story_part_one: '/wielki-powrot-butelki',
  programming_34_skribot_story_part_two: '/do-mlynka',
  programming_35_skribot_story_part_three: '/dziel-i-myj',
  programming_36_skribot_story_part_four: '/drugie-zycie-butelki-pet',
  programming_37_finish: '/dziekujemy-za-udzial',
};



// WEBPACK FOOTER //
// ./src/config/routeMap.js